<script>
export default {
  name: "InnerSwitch",
  functional: true,
  render: function (h, {props, parent, children, listeners, data, ...args}) {
    let {name, value,showLabel,disabled=false, showMode} = props;
    const { ChannelId, Desc } = props.tem;

    const { ClassSku } = props.deviceModel

    const { ClassSkus = [], isAgriculture}  = props.batchSetAgricultureChannelSkus || {}
    
    const shouldShowDesc = ClassSkus.includes(ClassSku) && ChannelId!== 65535 && isAgriculture && showMode === 0;

    
    if(!value) value = 0;
    const change = listeners.change;
    return (<div class={"scence_ctr_div_switch_mian  "+ data.class}>
      {name && showLabel && 
      <span class="scence_ctr_span_title">{ name }
       {shouldShowDesc && Desc && <span class={"scence_ctr_span_desc"}>({Desc})</span>}
      </span>}
      <div class={"scence_ctr_div_switch" + (name ? "" :  " nest")}>
        <el-switch value={value}
          active-color="#7dacee"
          inactive-color="#d9e2f0"
          active-value={1}
          inactive-value={0}
          onChange={change} 
          disabled={disabled}
        />
    </div>
    </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";
.scence_ctr_span_desc{
  margin-left: 5px;
}
</style>
